import React, { useContext, useEffect, useState } from 'react';
import { FaList, FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';
import AppContext from '../../../context/AppContext';
import AdmNotiCard from '../../../components/admin/AdminNotifications/AdmNotiCard';

const TABS = [
  { key: 'all',    label: 'All',    icon: FaList,        color: '#2C5F7C' },
  { key: 'unread', label: 'Unread', icon: FaEnvelope,    color: '#FFB800' },
  { key: 'read',   label: 'Read',   icon: FaCheckCircle, color: '#28A745' },
];

const AdmNotiList = () => {
  const { authToken, baseUrl, notifications, setnotification } = useContext(AppContext);

  const [loading,    setLoading]    = useState(true);
  const [fetchError, setFetchError] = useState('');
  const [activeTab,  setActiveTab]  = useState('all');

  useEffect(() => {
    setLoading(true);
    setFetchError('');

    axios
      .get(`${baseUrl}/admin/view-adminnotiview`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) setnotification(res.data.data || []);
      })
      .catch((err) => {
        console.error('Notifications fetch error:', err);
        setFetchError('Failed to load notifications. Please try again.');
      })
      .finally(() => setLoading(false));
  }, [authToken, baseUrl]);        

  const handleMarkRead = (id) => {
    axios.post(
      `${baseUrl}/admin/view-adminnotireadall`,
      {},
      {
        headers: { Authorization: `Bearer ${authToken}` },
      }
    )
    .then(() => {
      setnotification((prev) =>
        prev.map((n) => (n.id === id ? { ...n, status: 'read' } : n))
      );
    })
    .catch((err) => console.error('Mark read error:', err));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Delete this notification?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DC3545',
      confirmButtonText: 'Yes, delete',
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios.delete(
        `${baseUrl}/admin/view-adminnotidelete`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
          data: { id },
        }
      ) 
      .then(() => {
        setnotification((prev) => prev.filter((n) => n.id !== id));
        Swal.fire('Deleted!', 'Notification deleted successfully.', 'success');
      })
      .catch((err) => {
        Swal.fire('Error', err.response?.data?.message || 'Failed to delete notification.', 'error');
      });
    });
  };

  const filtered =
    activeTab === 'all'
      ? notifications
      : notifications.filter((n) => n.status === activeTab);

  const counts = {
    all:    notifications.length,
    unread: notifications.filter((n) => n.status === 'unread').length,
    read:   notifications.filter((n) => n.status === 'read').length,
  };

  return (
    <>
      {/* Filter tabs */}
      <div className="adm-noti-tabs">
        {TABS.map(({ key, label, icon: Icon, color }) => (
          <button
            key={key}
            className={`adm-noti-tab ${activeTab === key ? 'active' : ''}`}
            onClick={() => setActiveTab(key)}
            style={activeTab === key ? { borderColor: color } : {}}
          >
            <Icon />
            <span>{label}</span>
            <span className="adm-noti-tab-count">{counts[key]}</span>
          </button>
        ))}
      </div>

      {loading ? (
        <div className="adm-noti-loading">
          <div className="adm-noti-spinner" />
          <p>Loading notifications…</p>
        </div>
      ) : fetchError ? (
        <div className="adm-noti-error">{fetchError}</div>
      ) : filtered.length === 0 ? (
        <div className="adm-noti-empty">
          <div className="adm-noti-empty-emoji">📭</div>
          <h3>
            {activeTab === 'unread'
              ? 'No unread notifications'
              : activeTab === 'read'
              ? 'No read notifications'
              : 'No notifications yet'}
          </h3>
          <p>
            {activeTab === 'unread'
              ? "You're all caught up!"
              : "Nothing to show here."}
          </p>
        </div>
      ) : (
        <div className="adm-noti-list">
          {filtered.map((n) => (
            <AdmNotiCard
              key={n.id}
              notification={n}
              onMarkRead={handleMarkRead}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default AdmNotiList;  